const updates = [
  {
    id: 1,
    tag: '最新',
    tagColor: 'bg-primary-500 text-white',
    time: '10分钟前',
    title: '某知名男星深夜与神秘女子同行被拍，工作室火速回应引热议',
    summary: '狗仔曝光多张高清照片，男方工作室凌晨发声明否认恋情，网友逐帧分析照片细节。',
  },
  {
    id: 2,
    tag: '热议',
    tagColor: 'bg-accent-500 text-background-50',
    time: '28分钟前',
    title: '头部网红直播间口误引发品牌方集体解约，经济损失或超千万',
    summary: '该网红在直播中不当言论被截屏传播，多个合作品牌紧急发布解约声明。',
  },
  {
    id: 3,
    tag: '独家',
    tagColor: 'bg-primary-500 text-white',
    time: '1小时前',
    title: '选秀节目选手私下聊天记录曝光，节目组称正在核实真实性',
    summary: '涉及多位当红选手的群聊截图在网络疯传，内容劲爆引发粉丝圈震动。',
  },
  {
    id: 4,
    tag: '快讯',
    tagColor: 'bg-secondary-500 text-white',
    time: '2小时前',
    title: '某影视公司内部邮件泄露，年度重点项目被紧急叫停',
    summary: '邮件显示因主演出轨丑闻导致投资方撤资，剧组已暂停拍摄等待换角。',
  },
  {
    id: 5,
    tag: '追踪',
    tagColor: 'bg-accent-500 text-background-50',
    time: '3小时前',
    title: '上周曝光的主播刷单事件持续发酵，平台官方终于发声',
    summary: '平台公告称将对涉事主播进行永久封禁，并配合监管部门调查数据造假问题。',
  },
  {
    id: 6,
    tag: '爆料',
    tagColor: 'bg-primary-500 text-white',
    time: '5小时前',
    title: '知名综艺节目录制现场突发意外，知情人士爆料内幕',
    summary: '据现场工作人员透露，某常驻嘉宾因不满剪辑恶意剪辑当场翻脸离场。',
  },
  {
    id: 7,
    tag: '热点',
    tagColor: 'bg-accent-500 text-background-50',
    time: '7小时前',
    title: '二次元顶流UP主被扒出早年争议言论，粉丝脱粉潮涌现',
    summary: '网友考古发现该UP主多年前的不当发言，超话排名一夜暴跌引发行业讨论。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          最新快讯<i className="ri-flashlight-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时追踪 · 一刻不停</p>

        <div className="mt-8 relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden md:block"></div>
          <div className="flex flex-col gap-4">
            {updates.map((item, i) => (
              <article key={item.id} className="relative flex gap-4 md:gap-6">
                <div className="hidden md:flex flex-col items-center pt-1 flex-shrink-0">
                  <div className={`w-[10px] h-[10px] rounded-full border-2 border-background-50 ${i === 0 ? 'bg-primary-500' : 'bg-background-300'}`}></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/50 transition-colors">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}